<template>
  <div class="login">
    <div class="userform">
      <div class="logo"></div>
      <el-form class="loginform" :model="user" status-icon :rules="rules" ref="ruleForm">
        <el-form-item prop="nickname">
          <el-input v-model.number="user.nickname" prefix-icon="el-icon-user" :clearable="true" class="inputline"
            maxlength="20"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model="user.pwd" autocomplete="off" prefix-icon="el-icon-lock" :clearable="true"
            :show-password="true" class="inputline" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
      user: {
        nickname: '',
        pwd: '',
      },
      rules: {
        nickname: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    // userTest().then(res => {
    //   console.log(res)
    // })
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login()
        } else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    login() {

      this.$store
        .dispatch("user/login", { nickname: this.user.nickname, password: this.user.pwd })
        .then(() => {
          this.$router.push({
            path: this.$route.query.redirect || "/"
          });
        })
        .catch(error => {
          console.warn(error);
        });
    }
  }
}
</script>

<style lang="scss" scope>
.login {
  @extend %center;
  height: 100vh;
  background: $bg;
}

.userform {
  width: px(700);
  height: px(600);
  padding: px(200) 0 0 0;
  background: #fff;
  border-radius: px(16);
  box-sizing: border-box;
  @extend %center;
  position: relative;

  .logo {
    width: px(400);
    height: px(52.6);
    background: url(../assets/antialogo.png) no-repeat 0 0 #fff;
    background-size: cover;
    position: absolute;
    left: 50%;
    top: px(100);
    transform: translateX(-50%);
  }

  .loginform {
    width: px(400);

    .el-form-item__content {
      margin-bottom: px(40);
    }

    .inputline {
      input {
        padding-left: px(32);
        border: 0 solid transparent;
        border-bottom: px(1) solid #999;
        border-radius: 0;
        font-size: px(20);
      }

      .el-input__prefix {
        font-size: px(30);
        color: $c;
        transform: translate(px(-8), px(0));
      }
    }

    .el-button {
      width: px(400);
      height: px(50);
      padding: 0;
      font: px(24)/px(50) $font;
    }
  }
}
</style>